import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Check, Minus, Loader2, ShieldCheck, Info } from "lucide-react";

export default function MatrizPermissoes() {
  const [data, setData] = useState(null);

  useEffect(() => { api.get("/gestao/permissoes").then((r) => setData(r.data)); }, []);

  if (!data) return <div className="flex justify-center py-20"><Loader2 className="w-6 h-6 animate-spin text-primary" /></div>;

  const { roles, role_labels, matriz, meu_perfil } = data;

  return (
    <div className="space-y-5" data-testid="matriz-permissoes-page">
      <div>
        <div className="text-[11px] sm:text-xs text-primary uppercase tracking-[0.18em] font-bold">Gestão</div>
        <h1 className="font-display text-2xl sm:text-4xl font-extrabold uppercase flex items-center gap-2">
          <ShieldCheck className="w-7 h-7 text-primary" /> Matriz de Permissões
        </h1>
        <p className="text-sm text-muted-foreground mt-1">O que cada perfil pode fazer. Reflete as regras reais do sistema (somente leitura).</p>
      </div>

      <div className="flex flex-wrap items-center gap-4 text-xs text-muted-foreground">
        <span className="inline-flex items-center gap-1"><Check className="w-4 h-4 text-emerald-400" /> Permitido</span>
        <span className="inline-flex items-center gap-1"><Minus className="w-4 h-4 text-muted-foreground/60" /> Não permitido</span>
        <span className="inline-flex items-center gap-1"><Info className="w-3.5 h-3.5 text-sky-400" /> Limitado às unidades autorizadas (escopo)</span>
      </div>

      <Card className="bg-card/70 overflow-x-auto p-0">
        <table className="w-full text-sm border-collapse min-w-[720px]">
          <thead>
            <tr className="border-b border-border">
              <th className="text-left p-3 sticky left-0 bg-card z-10 min-w-[240px]">Ação</th>
              {roles.map((r) => (
                <th key={r} className={`p-3 text-center text-[11px] uppercase tracking-wide whitespace-nowrap ${r === meu_perfil ? "text-primary" : "text-muted-foreground"}`} data-testid={`perm-col-${r}`}>
                  {role_labels[r] || r}
                  {r === meu_perfil && <div className="text-[9px] font-bold text-primary">(você)</div>}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {matriz.map((grupo) => (
              <FragmentGroup key={grupo.modulo} grupo={grupo} roles={roles} meu={meu_perfil} />
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}

function FragmentGroup({ grupo, roles, meu }) {
  return (
    <>
      <tr className="bg-secondary/40">
        <td colSpan={roles.length + 1} className="px-3 py-2 font-display text-xs font-bold uppercase tracking-wide text-primary sticky left-0" data-testid={`perm-modulo-${grupo.modulo}`}>
          {grupo.modulo}
        </td>
      </tr>
      {grupo.caps.map((cap, i) => (
        <tr key={cap.acao} className="border-b border-border/50 hover:bg-secondary/20" data-testid={`perm-row-${grupo.modulo}-${i}`}>
          <td className="p-3 sticky left-0 bg-card z-10">
            <span>{cap.acao}</span>
            {cap.escopo && <span className="ml-1 inline-flex items-center" title="Limitado às unidades autorizadas"><Info className="w-3.5 h-3.5 text-sky-400 inline" /></span>}
          </td>
          {roles.map((r) => {
            const ok = cap.roles.includes(r);
            return (
              <td key={r} className={`p-3 text-center ${r === meu ? "bg-primary/5" : ""}`} data-testid={`perm-cell-${grupo.modulo}-${i}-${r}`}>
                {ok ? <Check className="w-4 h-4 text-emerald-400 mx-auto" /> : <Minus className="w-4 h-4 text-muted-foreground/40 mx-auto" />}
              </td>
            );
          })}
        </tr>
      ))}
    </>
  );
}
